import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const LandingPage = lazy(() => import('./landing/LandingPage'));
const PortfolioPage = lazy(() => import('./portfolio/PortfolioPage'));
const Game = lazy(() => import('./game/components/Game'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));

const pulse = keyframes`
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
`;

const LoadingScreen = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #030711;
  color: #ddedf9;
  font-family: 'Marcellus', 'Times New Roman', serif;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.14em;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingScreen>H&amp;Co</LoadingScreen>}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/game" element={<Game />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
